import {FETCHED_BTC} from '../../types';
import axios from 'axios';

export function getBTCBalanceDispatch(){
  return function(dispatch,getState){
    getBTCBalance(dispatch,getState())
  }
}

export async function getBTCBalance(dispatch,state) {
  let wallet = state.passport.wallet;
  let response = await axios.get(`https://api.blockcypher.com/v1/btc/main/addrs/${wallet.btc.address}`,{params:{cors:true}})
  if(response && response.data && response.data.final_balance){
    dispatch({
      type:FETCHED_BTC,
      payload: response.data.final_balance / Math.pow(10,8)
    });
  }
}
